import React from "react";

export function Collapsible({ children }) {
  return <div className="collapsible">{children}</div>;
}
